export const hasPermissions = (
  userPermissions: string[],
  requiredPermission: string[] | string[][] = []
) => {
  if (requiredPermission.length === 0) return true;
  if (Array.isArray(requiredPermission[0])) {
    return (requiredPermission as string[][]).some((group) =>
      group.every((permission) => userPermissions.includes(permission))
    );
  }
  return (requiredPermission as string[]).every((permission) =>
    userPermissions.includes(permission)
  );
};
